export default __webpack_public_path__ + "static/media/Gloves of Vicious Frenzy.653eea21.jpg";